import {Box, Menu, PopoverProps} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../../../i18n/translations';
import {useHistory, useLocation} from 'react-router-dom';
import {ScreenPaths} from '../../../../../../../../enums';
import {PlannerItem, PlannerItemDeleteData, PlannerItemRegisterData} from '../planner-item';
import {PlannerActivityItemMenu} from './planner-activity-item-menu';
import {PlannerAnniversaryItemMenu} from './planner-anniversary-item-menu';

type PlannerItemMenuProps = {
  anchorEl?: PopoverProps['anchorEl'];
  open: boolean;
  item: PlannerItem;
  onClose: () => void;
  onDelete: (data: PlannerItemDeleteData[]) => void;
  onRegister: (data: PlannerItemRegisterData) => void;
};

export function PlannerItemMenu({item, ...props}: PlannerItemMenuProps) {
  const history = useHistory();
  const location = useLocation();
  const {t} = useTranslation();
  // const timeoutId = useRef<NodeJS.Timeout>();

  return (
    <Menu
      onMouseDown={(evt) => {
        evt.stopPropagation();
        evt.preventDefault();
      }}
      id="planner-item-menu"
      anchorEl={props.anchorEl}
      open={props.open}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      onClose={props.onClose}
      sx={{
        '& .MuiPopover-paper': {
          padding: '6px',
          width: '364px',
          borderRadius: '5px',
          maxHeight: '60%',
        },
        '& .MuiMenu-list': {
          padding: 0,
        },
      }}
    >
      {(() => {
        if (item.type === 'activity') {
          return (
            <PlannerActivityItemMenu
              item={item}
              onExpand={(expanded) => {
                // Enable code below if the initial expanded state is false
                // // HACK: Resize the window to re-position the popover
                // clearTimeout(timeoutId.current);
                // if (expanded) {
                //   timeoutId.current = setTimeout(() => {
                //     window.dispatchEvent(new CustomEvent('resize'));
                //   }, 250);
                // }
              }}
              onClose={props.onClose}
              onDelete={props.onDelete}
              onRegister={props.onRegister}
              onPlan={(data) => {
                // Build new URL
                const activitiesSectorPath = ScreenPaths.Senior_CarePlan.replace(
                  ':activitiesSectorId',
                  data.item.activitiesSector.id
                );
                const userId = data.user.id;
                const newUrl = location.pathname.replace(
                  ScreenPaths.Entity_Planner_Calendar,
                  `${ScreenPaths.ProfessionalCaregiver_Seniors}/${userId}${activitiesSectorPath}`
                );

                // Navigate
                history.push(newUrl);
              }}
            />
          );
        }

        if (item.type === 'anniversary') {
          return <PlannerAnniversaryItemMenu onClose={props.onClose} item={item} />;
        }

        return (
          <Box sx={{flex: '1', color: 'error.main', fontWeight: 'bold'}}>
            {t(translations.planner.errors.unknown_item_type, {
              // @ts-ignore
              type: item.type,
            })}
          </Box>
        );
      })()}
    </Menu>
  );
}
